import React from 'react'

class MainStackBlock extends React.Component{
    clickHandle(url){
        window.location.href = url
    }
    render(){
        const content = this.props.data.contents[0].cover_urls
        return(
            <div className="MainStackBlock">
                <div className="feedTitle">{this.props.data.name}</div>
                <div className="MainStackBlock-wrap">
                    <div className="leftStackBlock" onClick={()=>this.clickHandle(content[0].advertisement_url_1)}>
                        <img src={content[0].cover_url} alt=""/>
                    </div>
                    <div className="rightStackBlock">
                        {/*<div className="rightStackBlock-wrap">*/}
                            <div className="StackBlockitem"  onClick={()=>this.clickHandle(content[1].advertisement_url_1)}>
                                <img src={content[1].cover_url} alt=""/>
                            </div>
                            <div className="StackBlockitem"  onClick={()=>this.clickHandle(content[2].advertisement_url_1)}>
                                <img src={content[2].cover_url} alt=""/>
                            </div>
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        )
    }
}

export default MainStackBlock


// WEBPACK FOOTER //
// ./src/components/main/MainStackBlock.js